var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "min-width": _vm.responsiveMinWidth,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title is-flex-items-center" }, [
          _c("span", { staticClass: "mso mso-24px mr-1" }, [
            _vm._v("car_gear"),
          ]),
          _c("span", [_vm._v("Vehicle Butterfly Selector")]),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("vehicle-butterfly-selector-v2", {
            ref: "vehicleButterflySelector",
            attrs: { entity: _vm.entity },
            model: {
              value: _vm.selectedItems,
              callback: function ($$v) {
                _vm.selectedItems = $$v
              },
              expression: "selectedItems",
            },
          }),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              display: "flex",
              "justify-content": "space-between",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { width: "100%" }, attrs: { align: "right" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Reset" },
                    on: { click: _vm.reset },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                    ]),
                    _c("span", [_vm._v("Reset")]),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Cancel" },
                    on: { click: _vm.cancel },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-close mdi-18px" }),
                    ]),
                    _c("span", [_vm._v("Cancel")]),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary tooltip",
                    attrs: { "data-tooltip": "Done" },
                    on: { click: _vm.done },
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-check mdi-18px" }),
                    ]),
                    _c("span", [_vm._v("Done")]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }